"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator");
/**
 * An iterator that takes elements from a given array or iterator of iterators in a round-robin manner.
 *
 * Based on LDF client's UnionIterator:
 * https://github.com/LinkedDataFragments/Client.js/blob/master/lib/sparql/UnionIterator.js
 */


var RoundRobinUnionIterator =
/*#__PURE__*/
function (_asynciterator_1$Buff) {
  _inherits(RoundRobinUnionIterator, _asynciterator_1$Buff);

  function RoundRobinUnionIterator(sources, options) {
    var _this;

    _classCallCheck(this, RoundRobinUnionIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoundRobinUnionIterator).call(this, options || {
      autoStart: false
    }));
    _this.sourcedEnded = false;
    _this.currentSource = 0;
    _this.listenersAttached = false;
    _this.sources = [];
    _this.sourceIterator = Array.isArray(sources) ? new asynciterator_1.ArrayIterator(sources) : sources;

    _this.sourceIterator.on('error', function (error) {
      return _this.emit('error', error);
    });

    return _this;
  }

  _createClass(RoundRobinUnionIterator, [{
    key: "_read",
    value: function _read(count, done) {
      var _this2 = this;

      if (!this.sourcedEnded) {
        // Fill the buffer once the source iterator becomes readable
        if (!this.listenersAttached) {
          this.listenersAttached = true;
          this.sourceIterator.on('readable', function () {
            return _this2._fillBuffer();
          });
        } // Poll for new sources


        var source;

        while (source = this.sourceIterator.read()) {
          source.on('error', function (error) {
            return _this2.emit('error', error);
          });
          source.on('readable', function () {
            return _this2._fillBuffer();
          });
          source.on('end', function () {
            return _this2._fillBuffer();
          });
          this.sources.push(source);
        }

        if (this.sourceIterator.ended) {
          this.sourcedEnded = true;
        }
      }

      var item = null;
      var attempts = this.sources.length; // Iterate over all sources once

      while (this.sources.length && item === null && attempts--) {
        var _source = this.sources[this.currentSource]; // Read from the current source

        item = _source.read(); // Remove the source if it has ended, otherwise, increment our stored position

        if (_source.ended) {
          this.sources.splice(this.currentSource, 1);
        } else {
          this.currentSource++;
        }

        this.currentSource = this.sources.length ? this.currentSource % this.sources.length : 0;
      } // Push to the buffer if we have an item


      if (item !== null) {
        this._push(item);
      } // Otherwise close


      if (!this.sources.length && this.sourcedEnded) {
        this.close();
      }

      done();
    }
  }]);

  return RoundRobinUnionIterator;
}(asynciterator_1.BufferedIterator);

exports.RoundRobinUnionIterator = RoundRobinUnionIterator;